<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="ion-title-icon">{{'Administrar ' | translate}}{{(getNomenclatura(tipo) | nomenclatura |
      async)}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido-div">
    <div class="div-top">
      <ion-note slot="start">
        <i class="fas fa-cog div-icon" style="margin-top: 2px;"></i>
      </ion-note>

      <ion-label class="color-title" *ngIf="userProvider.hasConfig(184)">
        {{'Administrar ' | translate}} {{(getNomenclatura(tipo) | nomenclatura | async)}}
      </ion-label>

      <ion-note slot="end" (click)="filtroMensagem();">
        <i class="fa fa-filter icon-card" style="float: right; margin: 9px 33px 3px 52px;"></i>
      </ion-note>
    </div>

    <div *ngFor="let oracao of oracoes">
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-card class="top-card-all">
              <ion-grid>
                <ion-row>
                  <ion-col class="remove-border">
                    <ion-item>
                      <ion-avatar slot="start">
                        <img src="{{oracao.pessoa.foto | image:' '}}" class="avatar-image" />
                      </ion-avatar>

                      <ion-label>
                        <h2 class="grupo bold-2">
                          {{oracao.pessoa.nome}}
                        </h2>

                        <p class="bold-1">
                          <span class="bold-1">{{oracao.data | dateFormat:'L HH:mm'}}</span>
                        </p>
                      </ion-label>

                      <ion-note slot="end" class="icon-card" (click)="opcoesAdm(oracao)">
                        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                      </ion-note>
                    </ion-item>
                  </ion-col>
                </ion-row>

                <ion-row class="down-card">
                  <ion-col class="remove-border">
                    <ion-item>
                      <ion-label class="badges">
                        <div class="badge-left">
                          <ion-badge color="tertiary" *ngIf="oracao.formaPedido == 'SISTEMA'">Sistema</ion-badge>
                          <ion-badge color="tertiary" *ngIf="oracao.formaPedido == 'APLICATIVO'">Aplicativo</ion-badge>
                          <ion-badge color="tertiary" *ngIf="oracao.formaPedido == 'SITE'">Site</ion-badge>

                          <ion-badge color="danger" *ngIf="oracao.privacidade == 'PUBLICO'">Público</ion-badge>
                          <ion-badge color="danger" *ngIf="oracao.privacidade == 'PRIVADO'">Privado</ion-badge>

                          <ion-badge color="success" *ngIf="oracao.isTestemunho == '1'">Testemunho</ion-badge>
                          <ion-badge color="secondary" *ngIf="oracao.isTestemunho == '0'">{{'oracao' | nomenclatura |
                            async}}</ion-badge>
                        </div>

                        <div>
                          <p class="pedido">
                            <span class="bold-1"> {{oracao.pedido}} </span>
                          </p>
                        </div>
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>

            <ion-row class="remove-border">
              <ion-item *ngIf="oracao.privacidade == 'PUBLICO'">
                <ion-label class="font-privacidade">{{'Liberar para listagem pública' | translate}}?</ion-label>

                <ion-note slot="end">
                  <ion-toggle [enableOnOffLabels]="true" id="bg" (ionChange)="mudarPublico(oracao)" [checked]="oracao.liberado == '1'">
                  </ion-toggle>
                </ion-note>
              </ion-item>

              <ion-col>
                <ion-button expand="block" fill="outline" class="btn-danger" (click)="excluirOracao(oracao)">
                  <div>{{'Excluir' | translate}}</div>
                </ion-button>
              </ion-col>

              <ion-col *ngIf="oracao.status == '1'">
                <ion-button expand="block" class="btn-default" (click)='responder(oracao);'>
                  <div>{{'Responder' | translate}}</div>
                </ion-button>
              </ion-col>

              <ion-col *ngIf="oracao.status == '2'">
                <ion-button expand="block" class="btn-success" (click)='responder(oracao);'>
                  <ion-icon class="icon-space" name="checkmark-circle"></ion-icon>
                  <div>{{'Respondido' | translate}}</div>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="remove-border" [hidden]="oracoes.length">
      <ion-item style="padding: 0px 0px 0px 50px;">
        <sem-registro [hidden]="oracoes.length"></sem-registro>
      </ion-item>
    </div>

    <ion-infinite-scroll (ionInfinite)="loadAdmOracoes($event)" *ngIf="pagination.currentPage < pagination.pageCount">
      <ion-infinite-scroll-content loadingText="(Carregando | translate)...">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <ion-grid>
      <ion-row class="ion-justify-content-start">
        <ion-col>
          <div class="pd-5">
            <ion-button expand="block" class="btn-default" (click)="openNova(null)"
              *ngIf="!userProvider.hasConfig(184)">
              {{'Enviar Pedido de ' | translate}}{{'oracao' | nomenclatura | async}}/{{'testemunho' | nomenclatura |
              async}}
            </ion-button>

            <ion-button expand="block" class="btn-default" (click)="openNova(null)" *ngIf="userProvider.hasConfig(184)">
              {{'Enviar Pedido de ' | translate}}{{(getNomenclatura(tipo) | nomenclatura | async)}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>